var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#C2CFE0",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2925 7.71255L11.4125 11.5925L15.2925 15.4725C15.6825 15.8625 15.6825 16.4925 15.2925 16.8825C14.9025 17.2725 14.2725 17.2725 13.8825 16.8825L9.29246 12.2925C8.90246 11.9025 8.90246 11.2725 9.29246 10.8825L13.8825 6.29255C14.2725 5.90255 14.9025 5.90255 15.2925 6.29255C15.6725 6.68255 15.6825 7.32255 15.2925 7.71255Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/ArrowLeft.c01e43a0.svg";
export { ForwardRef as ReactComponent };